// src/pages/Privacy.js
import React from 'react';

const Privacy = () => (
  <div className="container">
    <h1>Privacy Policy</h1>
    <p>We collect names, email addresses, and postcodes solely to provide community updates and verify local eligibility for CWARA membership.</p>
    <p>Your data will never be sold or shared and is only accessible to committee members who manage the mailing list.</p>
    <p>If you wish to be removed or request access to your data, please email us at <strong>admin@CWARA.org.uk</strong>.</p>
    <p style={{ fontSize: '0.85rem', color: '#666', marginTop: '24px' }}>
      This is a summary of our policy. <a href="/privacy-full">Click here for our full privacy policy</a> (to be published).
    </p>
  </div>
);

export default Privacy;
